import React, { useEffect, useRef, useState } from "react";
// import { PageDialogContent, PageDialogFooter } from "./MianPageDialog";
// import { BtnComponent } from "helpers/common.lib";
// import { SectionHeader } from "./form/renderer";

import { Editor } from "@tinymce/tinymce-react";
import { useSelector, shallowEqual } from "react-redux";
import { BtnComponent } from "../../../components/button";
import MainPageDialog, {
  PageDialogContent,
  PageDialogFooter,
} from "../../../components/dialog";

export const TinyEditor = ({
  template_name,
  defaultTemplate,
  document_id,
  is_signed = 0,
  setSelectedLetter = () => {},
  signTemplate = () => {},
  signingLetter = false,
  readOnly = false,
  printAction = null,
  ...props
}) => {
  const {
    // practice: { id: practice_id },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));
  // const { authToken } = useSelector(
  //   ({ auth }) => ({
  //     authToken: auth && auth.authToken,
  //   }),
  //   shallowEqual
  // );
  const [loadingState, setLoadingState] = useState("save");
  const editorRef = useRef(null);
  const [content, setContent] = useState("");

  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };
  const onEditorChange = function (a, editor) {
    // console.log(a);
    setContent(a);
    setText(editor.getContent({ format: "text" }));
    //console.log(editor);
  };

  let fileUrl = `${
    process.env.REACT_APP_API_URL_V1
  }/documents/view.json?id=${document_id}&token=${authToken}&tz=${new Date().getTimezoneOffset()}`;

  const [text, setText] = useState();

  useEffect(() => {
    if (defaultTemplate) setContent(defaultTemplate);
  }, [defaultTemplate]);

  const editorActions = [
    {
      title: "Cancel",
      type: "cancel",
      action: () => setSelectedLetter(null),
    },
    // {
    //   title: "Save",
    //   type: "save",
    //   action: () => {
    //     setLoadingState("save");
    //     signTemplate(editorRef.current.getContent());
    //   },
    //   disabled: signingLetter,
    //   loading: loadingState == "save" && signingLetter,
    // },
    // {
    //   type: "save",
    //   title: is_signed ? "UnSign" : "Sign and Attach to Preview",
    //   action: () => {
    //     setLoadingState("sign");
    //     signTemplate(editorRef.current.getContent(), is_signed == 0 ? 1 : 0);
    //   },
    //   disabled: signingLetter,
    //   loading: loadingState == "sign" && signingLetter,
    // },
  ];
  // if (is_signed == 1) {
  //   editorActions.push({
  //     title: "Print",
  //     action: () =>
  //       printAction ? printAction() : window.open(fileUrl, "_blank"),
  //     disabled: signingLetter,
  //   });
  // }
  
  return (
    <>
      <MainPageDialog {...props} footerList={editorActions}>
        <Editor
          onEditorChange={onEditorChange}
          //initialValue={content}
          //outputFormat="text"
          disabled={readOnly}
          value={content}
          onInit={(evt, editor) => (editorRef.current = editor)}
          // initialValue="<p>This is the initial content of the editor.</p>"
          init={{
            height: 900,

            menubar: false,
            plugins: "lists media table wordcount image imagetools",
            toolbar:
              "undo redo | bold italic underline strikethrough | Superscript Subscript | fontfamily fontsize blocks | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | image template link anchor codesample | table | wordcount",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            emoticons_append: {
              custom_mind_explode: {
                keywords: ["brain", "mind", "explode", "blown"],
                char: "🤯",
              },
            },
          }}
        />
      </MainPageDialog>
    </>
  );
};
